// LocationForm.tsx
import React from "react";

import { Business } from "0.Mine/3.Interfaces/business";

import { useLocationFormLogic } from "../../Logic/BasicInfo/Location";
import LocationFormUI from "../../UI/LocationFormUI";

interface LocationFormProps {
  updateBusinessData: (data: Partial<Business>) => void;
  businessData: Partial<Business>;
}

const LocationForm: React.FC<LocationFormProps> = ({ updateBusinessData, businessData }) => {
  const { location, setField } = useLocationFormLogic({ updateBusinessData, businessData });

  return <LocationFormUI location={location} onFieldChange={setField} />;
};

export default LocationForm;
